import { UserRoles } from "./checkUserRoles";

const getAdminAppRole = (role: UserRoles) => {
  if (role === UserRoles.DetectorAdmin || role === UserRoles.DetectorUser)
    return UserRoles.DetectorAdmin;
  if (role === UserRoles.ResponderAdmin || role === UserRoles.ResponderUser)
    return UserRoles.ResponderAdmin;
  if (role === UserRoles.GmdAdmin || role === UserRoles.GmdUser)
    return UserRoles.GmdAdmin;
  if (
    role === UserRoles.InvestigatorAdmin ||
    role === UserRoles.InvestigatorAudit
  )
    return UserRoles.InvestigatorAdmin;
  if (role === UserRoles.GlobalAdmin) return UserRoles.GlobalAdmin;

  return undefined;
};

export default getAdminAppRole;
